/* ------------------------------------------------------------------
 * Magni Reveal — shared per-element scroll-in observer.
 *
 * Each [data-magni-reveal] element floats in as IT crosses the trigger line,
 * so the entrance stays in sync with the scroll position instead of firing the
 * whole section at once (which, on a slow scroll, finished below the fold and
 * left you arriving at already-settled content).
 *
 * BOTTOM_MARGIN is the one knob: a larger negative % fires LATER, so the float
 * completes nearer the centre of the screen where the eye actually sits. Too
 * large and elements stuck in the bottom slice of the page can't reach the line
 * — the scroll-to-bottom safety net below catches those so nothing strands.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  var BOTTOM_MARGIN = -14; // % of viewport height trimmed off the bottom

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var HAS_IO = 'IntersectionObserver' in window;

  // Arm the CSS hide only now that the script is actually running (and only when
  // we'll animate). A failed/stale/missing script never adds this class, so
  // [data-magni-reveal] elements stay visible instead of stranding at opacity:0.
  // Done synchronously at script execution (deferred = after parse) so the magni
  // sections — all below the hero — hide before they paint, with no flash.
  if (!REDUCE && !DESIGN) {
    document.documentElement.classList.add('magni-reveal-ready');
  }

  var io = null;
  function observer() {
    if (io || !HAS_IO) return io;
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('magni-reveal-in');
          io.unobserve(entries[i].target);
        }
      }
    }, { root: null, threshold: 0, rootMargin: '0px 0px ' + BOTTOM_MARGIN + '% 0px' });
    return io;
  }

  function pending(root) {
    return (root || document).querySelectorAll(
      '[data-magni-reveal]:not(.magni-reveal-in):not(.magni-reveal-static)'
    );
  }

  function setup(root) {
    var els = pending(root);
    if (!els.length) return;
    // Editor + reduced-motion + no-IO: reveal immediately, no scroll dependency.
    if (DESIGN || REDUCE || !HAS_IO) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('magni-reveal-static');
      return;
    }
    var obs = observer();
    for (var j = 0; j < els.length; j++) obs.observe(els[j]);
  }

  // Safety net: once the page is scrolled to its bottom, reveal anything still
  // hidden (elements in the bottom slice never reach the raised trigger line).
  function sweepBottom() {
    if (DESIGN || REDUCE) return;
    var atBottom = window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 4;
    if (!atBottom) return;
    var els = pending(document);
    for (var i = 0; i < els.length; i++) {
      els[i].classList.add('magni-reveal-in');
      if (io) io.unobserve(els[i]);
    }
  }

  function init() { setup(document); }

  if (window.MagniRevealBound) return;
  window.MagniRevealBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { sweepBottom(); ticking = false; });
  }, { passive: true });

  // Theme editor re-renders a section — re-scan it for newly added tagged nodes.
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
